import React from "react";
import DashboardCard from "./DashboardCard";

const toneClasses = {
  blue: "bg-customAccentBlue text-white",
  green: "bg-customFontLightGreen text-white dark:bg-customDarkGreen",
  sky: "bg-customAccentBlue text-white dark:bg-customBlue",
  orange: "bg-customOrange text-white dark:bg-customMustardYellow dark:text-customBlack",
};

const MetricCards = ({ metrics = [] }) => {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <DashboardCard key={metric.label} className="flex min-h-[92px] items-center gap-3 p-3">
            <div className={`grid h-12 w-12 shrink-0 place-items-center rounded-full ${toneClasses[metric.tone]}`}>
              <Icon className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-customSecondaryText dark:text-customMuted">{metric.label}</p>
              <p className="mt-1 truncate text-xl font-bold text-customInk dark:text-customHeading">{metric.value}</p>
              <p
                className={`mt-1 text-[11px] font-semibold ${
                  metric.negative
                    ? "text-customFontRed"
                    : metric.neutral
                    ? "text-customSecondaryText dark:text-customMuted"
                    : "text-customFontLightGreen dark:text-customDarkGreen"
                }`}
              >
                {metric.neutral ? metric.change : `${metric.negative ? "Down" : "Up"} ${metric.change}`}
                {metric.detail ? (
                  <span className="ml-1 font-medium text-customSecondaryText dark:text-customMuted">{metric.detail}</span>
                ) : null}
              </p>
            </div>
          </DashboardCard>
        );
      })}
    </div>
  );
};

export default MetricCards;
